import styled from 'styled-components'

export const FullHeaderContainer = styled.header`
    position: sticky;
    top: 0;
    left: 0;
    background: #ffffff;
    z-index: 0;
`

export const HeaderLinkCreate = styled.div`
    border-bottom: 1px solid #dee2e6;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;
    padding: 1.5rem;
`

export const Title = styled.h1`
    max-width: 80%;
    max-height: 100%;
    flex-wrap: wrap;
    word-break: break-word;
    overflow: hidden;
    font-size: 1.25rem;
    margin: 0;

    font-family: 'Inter';
    font-weight: 500;
`

export const TitleForm = styled.h2`
    /* font-size: 1.5rem; */
    font-family: 'Inter';
    /* line-height: 1.2; */
    /* font-weight: 600; */
`

export const Form = styled.form`
    margin-bottom: 15px;

    .input-group {
        /* margin-top: 30px; */
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 10px;

        p {
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 29px;
        }
    }
`

export const SelectStyle = styled.div`
    .css-1jqq78o-placeholder {
        color: rgb(156, 163, 175);
    }
    /* .css-qbdosj-Input {
  input {
    &::placeholder {
    }
  }
} */
    .css-t3ipsp-control {
        border-color: rgb(37, 99, 235);
    }
    .css-13cymwt-control:hover {
        /* border-color: rgb(37, 99, 235) */
    }
    .css-13cymwt-control {
        border-color: red;
        flex: 1 1 0%;
        font-size: 1rem /* 16px */;
        line-height: 1.5rem /* 24px */;
        color: rgb(156, 163, 175);
        border-color: transparent;
        border-color: rgb(209, 213, 219);
        border-width: 1px;
        border-radius: 0.5rem /* 8px */;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        background: white;
        &:focus {
            /* border-color: transparent; */
            /* outline: 2px solid transparent; */
            /* outline-offset: 2px; */
            /* border-color: red; */
        }
    }
    .css-1fdsijx-ValueContainer {
        padding-top: 0.24rem /* 8px */;
        padding-bottom: 0.24rem /* 8px */;
        padding-left: 1rem /* 16px */;
        padding-right: 1rem /* 16px */;
    }
    .css-1xc3v61-indicatorContainer {
    }
`

export const FooterLink = styled.footer`
    flex-shrink: 0;
    background: #ffffff;
    position: sticky;
    bottom: 0;
    left: 0;
    height: 4.5rem;
    width: 100%;
    padding: 0 1rem;
    border-top: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    z-index: 100;
`

export const ButtonNext = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    color: #ffffff;
    background-color: #08267d;
    border-color: #0030b9;

    display: inline-flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
`

export const ButtonBack = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    display: inline-flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
`

export const PaymentTypeDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`

export const Type = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 120px;
    width: 182px;
    width: max(100px, min(150px, 22vw));
    height: max(95px, min(135px, 22vw));
    padding: 4px;
    border-style: solid;
    cursor: pointer;

    p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: max(13px, min(16px, 3vw));
        /* font-size: min(10px, max(17px, 22vw)); */
        /* line-height: 22px; */
        text-align: center;
    }
    svg {
        font-size: max(27px, min(40px, 8vw));
        flex-shrink: 0;
    }
`

export const OptionsDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap: 29px;
    flex-wrap: wrap;
    gap: 10px 29px;
`

export const IconType = styled.img`
    margin-top: 16px;
`

export const ExplainText = styled.h4`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;

    margin-top: 11px;
    margin-bottom: 20px;
    color: #7e7979;

    max-width: 540px;
`

export const FrequencyPayment = styled.h3`
    margin-bottom: 10px;
`

export const SummarySection = styled.section`
    /* margin-top: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    h2.title {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 29px;
        text-align: center;
    }
`

export const InfoPayment = styled.div`
    padding: 26px 62px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-color: rgb(209 213 219);
    /* box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow); */
    border: 1px solid rgb(209 213 219);
    border-radius: 0.5rem;
    background-color: white;
    width: 480px;

    h4 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 29px;

        color: #676767;
    }

    h5 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        display: flex;
        align-items: center;

        color: #000000;
    }
`

export const InfoAndEdit = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 25px;

    h2 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 34px;

        color: #011e5b;
    }
`

export const InfoAndEdit2 = styled.div`
    margin-top: 10px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 25px;

    h2 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 34px;

        color: #011e5b;
    }
`

export const BillingValue = styled.div`
    > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    h5 {
        color: #212529;
    }
`

export const Edit = styled.button`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    span {
        font-size: 16px;
        font-weight: 400;
        color: #0030b9;
        line-height: 1.5;
        cursor: pointer;
    }
`

export const ReceiverValue = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 25px;

    h4 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 29px;

        color: #676767;
    }

    h3 {
        color: #212529;
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 1.5;
    }
`

export const Container = styled.div``
export const Leftside = styled.div``
export const Rightside = styled.div``
